import api from '@/api'
export default {
  userTalentOpinionAdd (data) {
    return api({
      url: '/user/userTalentOpinionAdd',
      method: 'POST',
      data
    })
  }
}
